import { createFileRoute } from '@tanstack/react-router'
import { AlternativesPage, alternativesHead, type AlternativesData } from '@/components/alternatives-page'
import { MONITOR_LOCATIONS } from '@/lib/check-locations'

const data: AlternativesData = {
  tool: "Pulsetic",
  slug: "pulsetic",
  intro: "Pulsetic focuses on status pages, with 30-second checks on its Team plan. If you need faster checks on an entry plan or different alerting, here are alternatives.",
  alternatives: [
    {
      name: "Better Stack",
      description: "Uptime monitoring combined with on-call, incident management, logs, and status pages in one platform.",
      pricing: "Free (10 monitors), paid from $34/mo per responder",
      pros: ["On-call scheduling and incident management", "Unlimited phone and SMS alerts on paid plans", "Multi-location confirmation (3 of 4 locations by default)"],
      cons: ["Priced per responder, plus monitor packs", "More product than you need if you only want uptime checks"],
      url: "https://betterstack.com",
    },
    {
      name: "Uptrack",
      description: "Uptime monitoring with 30-second checks and alert confirmation. Pro includes 50 monitors for $3/mo.",
      pricing: "Free (5 monitors), Pro $3/mo, Team $20/mo, Business $79/mo",
      pros: ["30-second checks on every plan", "Alerts only after 2-5 consecutive failed checks", "Flat pricing with a 30-day money-back guarantee"],
      cons: ["Free plan is 5 monitors at 30 s from one location", MONITOR_LOCATIONS.alternativesCon, "No APM or logs"],
      url: "https://uptrack.app",
      isUptrack: true,
    },
    {
      name: "UptimeRobot",
      description: "A widely used uptime monitor with a free plan of 50 monitors at 5-minute checks, now allowed for commercial use. 30-second checks start on the Team plan.",
      pricing: "Free (50 monitors), Solo $10/mo, Team $41/mo",
      pros: ["Free plan with 50 monitors, commercial use allowed", "Mobile apps for iOS and Android", "15-second checks on the Scale plan"],
      cons: ["Free plan checks every 5 minutes; Solo every 60 seconds", "30-second checks start at $41/mo (Team)"],
      url: "https://uptimerobot.com",
    },
    {
      name: "Hyperping",
      description: "Uptime monitoring, browser checks, on-call, and status pages, checked from 18 regions.",
      pricing: "Free (20 monitors), Essentials $24/mo",
      pros: ["Multi-region confirmation before an outage opens", "Browser checks and built-in on-call", "20-second checks on the Business plan"],
      cons: ["30-second checks start at $24/mo (Essentials)", "Extra seats cost $7-12/mo each"],
      url: "https://hyperping.com",
    },
    {
      name: "Oh Dear",
      description: "Site health monitoring: uptime, SSL, DNS, broken links, mixed content, Lighthouse, cron, and status pages.",
      pricing: "From $17/mo (2 sites), 10-day trial",
      pros: ["Broken link and mixed content checks", "Application health checks for Laravel/PHP apps", "Unlimited users on all plans"],
      cons: ["No free plan", "1-minute check interval"],
      url: "https://ohdear.app",
    },
  ],
  comparisonTable: [
    { tool: "Better Stack", freePlan: "10 monitors", checkInterval: "3min (free), 30s (paid)", alertConfirmation: "Yes (multi-location)", startingPrice: "$34/mo per responder" },
    { tool: "Uptrack", freePlan: "5 monitors at 30s", checkInterval: "30s (all plans)", alertConfirmation: "Yes (2-5 consecutive)", startingPrice: "Free; Pro $3/mo" },
    { tool: "UptimeRobot", freePlan: "50 monitors", checkInterval: "5min (free), 30s (Team)", alertConfirmation: "Multi-location for timeouts", startingPrice: "$10/mo" },
    { tool: "Hyperping", freePlan: "20 monitors", checkInterval: "5min (free), 30s (Essentials)", alertConfirmation: "Yes (multi-region)", startingPrice: "$24/mo" },
    { tool: "Oh Dear", freePlan: "None", checkInterval: "1min", alertConfirmation: "Yes (second location)", startingPrice: "$17/mo" },
  ],
}

export const Route = createFileRoute('/_site/alternatives/pulsetic')({
  component: () => <AlternativesPage data={data} />,
  head: () => alternativesHead(data),
})
